import {charcoal} from '../sass/base/_exports.sass';

export const InboxIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.36082 6H24.6392C25.1248 6 25.5285 6.40231 25.5658 6.9233L26.2092 15.9233C26.211 15.9488 26.2119 15.9744 26.2119 16H20.6406C19.9382 16 19.3688 16.6268 19.3688 17.4C19.3688 17.7303 19.1904 18.4591 18.6784 19.1026C18.2081 19.6937 17.4665 20.2 16.309 20.2C15.1523 20.2 14.411 19.6939 13.9408 19.1027C13.4289 18.4591 13.2504 17.7303 13.2504 17.4C13.2504 16.6268 12.6811 16 11.9787 16H5.78807C5.78807 15.9744 5.78898 15.9488 5.7908 15.9233L6.4342 6.92331C6.47145 6.40231 6.8752 6 7.36082 6ZM5.98549 18.8L6.43421 25.0767C6.47145 25.5977 6.8752 26 7.36082 26H24.6392C25.1248 26 25.5285 25.5977 25.5658 25.0767L26.0145 18.8H21.6988C21.4871 19.5298 21.1181 20.2859 20.5918 20.9474C19.6698 22.1063 18.2457 23 16.309 23C14.3728 23 12.949 22.1061 12.0272 20.9473C11.5011 20.2858 11.1322 19.5297 10.9205 18.8H5.98549ZM3.65435 6.69322C3.80333 4.60923 5.41833 3 7.36082 3H24.6392C26.5817 3 28.1967 4.60922 28.3457 6.69321L28.989 15.6932C29.0037 15.8974 29.0037 16.1026 28.989 16.3068L28.3457 25.3068C28.1967 27.3908 26.5817 29 24.6392 29H7.36082C5.41833 29 3.80333 27.3908 3.65435 25.3068L3.01095 16.3068C2.99635 16.1026 2.99635 15.8974 3.01095 15.6932L3.65435 6.69322Z"
        fill={color}
      />
    </svg>
  );
};
